<template>
  <div>
    <v-divider class="my-4"></v-divider>
    <v-list density="compact" class="py-0">
      <v-list-item class="px-0" :title="beneficiario.nome" :subtitle="`CPF: ${beneficiario.cpf}`">
        <template v-slot:title="{ title }">
          <div class="text-subtitle-1 font-weight-bold">{{ title }}</div>
        </template>
      </v-list-item>
      <v-list-item class="px-0" prepend-icon="mdi-phone" :title="beneficiario.phone || 'Não informado'"></v-list-item>
      <v-list-item class="px-0" prepend-icon="mdi-email" :title="beneficiario.email || 'Não informado'"></v-list-item>
    </v-list>
  </div>
</template>

<script setup>
defineProps({
  beneficiario: {
    type: Object,
    required: true,
  },
});
</script>